import React from 'react';
import { Section } from '../ui/Section';
import { motion } from 'framer-motion';
export function WhoSection() {
  return <Section variant="darker" className="border-t border-neutral-900" data-id="element-159">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6
    }} className="space-y-8" data-id="element-160">
        <h2 className="text-3xl font-bold text-white uppercase tracking-tight" data-id="element-161">
          Para quién es esto
        </h2>

        <div className="text-lg text-neutral-300 leading-relaxed space-y-6" data-id="element-162">
          <p data-id="element-163">
            Si tienes entre 30 y 65, vives en USA, hablas español… y sientes que
            tu trabajo te está drenando pero{' '}
            <strong className="text-white bg-red-900/20 px-1" data-id="element-164">
              no puedes renunciar
            </strong>{' '}
            porque hay cuentas, familia, edad, seguro médico o miedo…
          </p>

          <p className="text-xl font-medium text-white" data-id="element-165">Este PDF es para ti.</p>

          <div className="pl-4 border-l-4 border-red-600 py-2" data-id="element-166">
            <p className="text-neutral-400" data-id="element-167">No para “motivarte”.</p>
            <p className="text-white font-bold text-xl mt-1" data-id="element-168">
              Para devolverte control.
            </p>
          </div>
        </div>
      </motion.div>
    </Section>;
}